import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/V1/BlackList'

const BlackListInfo = {
  OnTheBlackList(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/OnTheBlackList`,
      data
    })
  },
  PublicPageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PublicPageData`,
      data
    })
  },
  PageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PageData`,
      data
    })
  },
  List(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/List`,
      data
    })
  },
  Create(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Create`,
      data
    })
  },
  Detail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}`,
      params
    })
  },
  Modify(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Modify`,
      data
    })
  },
  Delete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Delete`,
      data
    })
  }
}

export default BlackListInfo
